import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from "axios";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useSelector, useDispatch } from "react-redux";
import * as Actions from "../../../store/actions"
import { isMobileSafari } from 'react-device-detect';
import { VERSION_NO } from '../../../store/actions';

const ConsentFormDialog = props => {

    const dispatch = useDispatch()

    const [buttonText, setButtonText] = useState("Agree");
    const [meetingStarted, setMeetingStarted] = useState(false);
    const VerifyData = useSelector(({ auth }) => auth.VerifyData);
    const HasLeftMeeting = useSelector(({ meeting }) => meeting.HasLeftMeeting);
    const baseURL = useSelector(({ utils }) => utils.baseURL);
    const IsMeeting = useSelector(({ meeting }) => meeting.MeetingOn)

    useEffect(() => {
        if (meetingStarted && props.isLive) {
            setMeetingStarted(false)
            handleLiveChange()
        }
    }, [props.isLive])

    const handleLiveChange = () => {
        // setTimeout(() => {
        // props.JoinMeeting()
        props.close()
        // }, 5000);
    }
    const handleClose = () => {
        if (!meetingStarted) {
            props.close()
        }
    }
    const handleSubmit = () => {
        if (!props.isLive) {
            dispatch({ 
                
                type: Actions.MEETING_LEFT,
                payload: false,
            })
            axios.post(baseURL + `/PT2/httpdocs/${VERSION_NO}/sendPatientInWaitingRoomOnVC`, {
                "userNDme": props.name || "",
                "userType": "patient",
                "hostId": VerifyData?.hostId,
                "groupVideoRoomId": VerifyData?.groupVideoRoomId,
                "token": VerifyData?.uniqueSessionId
            });
            setButtonText("Please wait for meeting to start!")
            setMeetingStarted(true);
            props.clickAgress()
            props.close()
        } else {
            // props.JoinMeeting()
            props.close()
        }
        props.clickAgress()
    };

    return (
        <Modal
            backdropClassName="consentFormBackdrop"

            isOpen={props.isOpen}
            toggle={handleClose}
            size="lg"
            centered

        >
            <ModalHeader style={{width:"100%"}} toggle={() => props.close()}>
                <div style={{width:"100%"}}>
                <h5 style={{textAlign:"center",fontSize:"24px",color:"#3182ba"}}>Consent Form</h5>
                </div>
            </ModalHeader>
            <ModalBody style={{ height:isMobileSafari ?   "50vh" :"65vh", }}>
                <iframe
                    src={props.formUrl}
                    style={{ height: "100%", width: "100%" }}
                />
            </ModalBody>
            <ModalFooter style={{ display: "flex", justifyContent: "space-between" }}>
                <Button color="primary" style={{background:"white",color:"#3182ba",}} onClick={() => {
                    props.close()
                    props.onDisagree()
                }}>Disagree</Button>
                <Button color="primary"  style={{background:"#3182ba",paddingLeft:"10px",paddingRight:"10px",borderColor:"#3182ba"}} onClick={handleSubmit}>
                    {
                        buttonText
                    }
                </Button>
            </ModalFooter>
        </Modal>
    )
}

ConsentFormDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    formUrl: PropTypes.string,
    isLive: PropTypes.bool.isRequired,
    JoinMeeting: PropTypes.func.isRequired,
}

export default ConsentFormDialog
